import styled, { css } from 'styled-components';

export const Results = styled.div`
  height: 100%;
`;

export const ResultsWrapper = styled.div<{ standardSpacing?: boolean }>`
  ${({ standardSpacing }) => css`
    position: relative;
    padding: ${standardSpacing ? '0 32px' : '20px 0'};
  `}
`;
